import { gate } from 'hub-http/gates';
export const AGENT_INBOX_GLOBAL_NAV = gate('AIRuntime::AgentInbox::GlobalNav');
export const AGENT_PLAN_MODE = gate('AgentBuilder:PlanMode');
export const CREATE_AGENT = gate('Workflows:ModernEditor');
export const CREATE_AGENT_AS_STARTER_PORTAL = gate('Breeze:AgentAccessStarterHoldover');
export const WORKFLOWS_MODERN_EDITOR = gate('Workflows:ModernEditor');
export const TOOLS_AUDIT = gate('AgentBuilder:ToolsAudit');
export const CUSTOM_ASSISTANT_CREATION = gate('BreezeAssistant:CustomAssistant:Creation');